import React from 'react'

import Td from '@components/Td'
import Tr from '@components/Tr'

interface EmptyRowProps {
	message: string
	tdAmount: number
}

export default function EmptyRow({ message, tdAmount }: EmptyRowProps) {
	return (
		<Tr>
			<Td colSpan={tdAmount}>{message}</Td>
		</Tr>
	)
}
